import type { QueryClient } from "@tanstack/react-query";

export const privateQueryKey = (kind: "notes" | "gifts", household: string | undefined, user: string | undefined) => [kind, household, user] as const;

/** Cancellation marks even non-abortable requests obsolete before removing their data. */
export function clearSessionCache(client: QueryClient) {
  void client.cancelQueries();
  client.clear();
}

/** A late authentication check must never restore a previous user's session. */
export function authRevision() {
  let revision = 0;
  return { next: () => ++revision, current: (value: number) => value === revision };
}
